module.exports = __webpack_public_path__ + "c2h4static/img/img-steps-1@2x.c93a44c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Course/img/img-steps-1@2x.png
// module id = diG8
// module chunks = 1